import { AnyString } from '../../utils/types';

export interface IFontFormats {
	woff2: string;
	eot?: string;
	woff?: string;
	ttf?: string;
	svg?: string;
}

export interface IFontFaceProperties {
	fontFamily: string;
	fontStretch?: string;
	fontStyle?: IFontStyle;
	fontWeight?: string;
	unicodeRange?: string;
}

export type IFontStyle = `normal` | `italic` | `oblique` | `initial` | `inherit` | AnyString;

/*
 * Interface represents a font face that can be added to the applet.
 */
export interface IAddFont extends IFontFaceProperties {
	/** Unique identifier for the font face. This is used to reference the font in the applet. */
	uid: string;
	/** Element to which the font face will be appended. */
	append: HTMLElement;
	/** Available formats for the font. */
	formats: IFontFormats;
}

export const VIFontFormats = {
	woff2: 'string',
	eot: '?string',
	woff: '?string',
	ttf: '?string',
	svg: '?string',
};

export const VIFontFaceProperties = {
	fontFamily: 'string',
	fontStretch: '?string',
	fontStyle: '?string',
	fontWeight: '?string',
	unicodeRange: '?string',
};

export const VIAddFont = Object.assign(VIFontFaceProperties, {
	uid: 'string',
	append: 'object',
	formats: VIFontFormats,
});
